import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactGA from 'react-ga';

import Loading from '../common/Loading';
import StatsContnet from './Stats/StatsContent';
import BusinessName from './BusinessName/businessName';
import Graphs from './Graphs';
import Footnote from '../Footnote';
import StatusSelectDropdown from '../DropdownMenu/DateRangeDropdown';
import UserTypeDropdownVisibility from '../DropdownMenu/UserTypeDropdown';
import { rangeType, guestType } from './constants';

import utils from '../../lib/utils';

import CsvChartModal from './CsvChartModal';
import FileDownload from './images/file_download.png';

import './index.scss';

const USER_TYPE_NEW = 'new';
const USER_TYPE_ALL = 'all';

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: moment()
        .startOf('month')
        .format('MMMM-YYYY'),
      monthDropdownVisibility: false,
      overviewType: USER_TYPE_ALL,
      isAdmin: false,
      dateRangeDropdownVisibility: false,
      userTypeDropdownVisibility: false,
      selectedDateRange: null,
      selectedUserType: null,
      revenueSortOrder: true,
      activeOutcomesTab: 'BOOKED',
      selectedCompareLocation: {},
      isChartModalOpen: false,
    };

    this.onDropdownVisibilityChange = this.onDropdownVisibilityChange.bind(
      this,
    );

    this.fetchMetrics = this.fetchMetrics.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'In Landing Page',
      label: 'Landing Page',
    });
    if (
      this.props.business &&
      this.props.business.clientUser &&
      this.props.business.clientUser.role === 'ADMIN'
    ) {
      this.setState({
        isAdmin: true,
      });
    }
    const { dashboard } = this.props;
    const { metrics } = dashboard;
    if (
      metrics &&
      metrics.trend &&
      metrics.trend.range_type &&
      metrics.trend.guest_type
    ) {
      this.setState(
        {
          selectedDateRange: metrics.trend.range_type,
          selectedUserType: metrics.trend.guest_type,
        },
        () => this.fetchMetrics(),
      );
    } else {
      this.setState(
        {
          selectedDateRange: 'FOUR_WEEKS',
          selectedUserType: 'ALL',
        },
        () => this.fetchMetrics(),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.business &&
      nextProps.business.clientUser &&
      nextProps.business.clientUser.role === 'ADMIN'
    ) {
      this.setState({
        isAdmin: true,
      });
    }
    const { dashboard, business } = nextProps;
    const { metrics } = dashboard;
    const { locations, selectedLocation } = business;
    if (
      business &&
      !utils.isEmptyObject(locations) &&
      utils.isEmptyObject(selectedLocation)
    ) {
      const brand_location = locations.filter((location) =>
        location.brand_ids.includes(location.studioId),
      );
      if (brand_location.length > 0) {
        this.props.setSelectedLocation(brand_location[0]);
      }
    }
    if (metrics.trend && metrics.trend.range_type && metrics.trend.guest_type) {
      this.setState({
        selectedDateRange: metrics.trend.range_type,
        selectedUserType: metrics.trend.guest_type,
      });
    }
    if (
      utils.isEmptyObject(this.state.selectedCompareLocation) &&
      !utils.isEmptyObject(locations)
    ) {
      let brand_location = locations.filter((location) =>
        location.brand_ids.includes(location.studioId),
      );
      if (brand_location.length > 0) {
        this.setState({ selectedCompareLocation: brand_location[0] });
      }
    }
  }

  onDropdownVisibilityChange(visibility) {
    this.setState({
      monthDropdownVisibility: visibility,
    });
  }

  openChartModal = () => {
    this.setState({ isChartModalOpen: true });
  };

  closeChartModal = () => {
    this.setState({ isChartModalOpen: false });
  };

  downloadReport = () => {
    const { business, auth } = this.props;
    const { selectedLocation } = business;
    const { selectedDateRange, selectedUserType } = this.state;
    const id = selectedLocation.studioId || auth.studio_id;
    const URL =
      window.Config.API_URL +
      '/business/dashboard/metrics/outcomes/report?business_id=' +
      id +
      '&guest_type=' +
      selectedUserType +
      '&range_type=' +
      selectedDateRange;
    window.open(URL, '_blank');
  };

  fetchMetrics() {
    const { auth } = this.props;
    const { selectedDateRange, selectedUserType } = this.state;
    if (auth.brand_ids.length > 0 || this.props.business.id) {
      this.props.getMetrics({
        business_id: auth.studio_id || this.props.business.id,
        selectedDateRange: selectedDateRange,
        selectedUserType: selectedUserType,
        brandlocation: true,
      });
    }
  }

  fetchMetricsOnFilterChange = () => {
    const { auth, business } = this.props;
    const { selectedLocation } = business;
    const { selectedDateRange, selectedUserType } = this.state;
    let brand_location = business.locations.filter((location) =>
      location.brand_ids.includes(location.studioId),
    );
    if (brand_location.length > 0) {
      this.setState({ selectedCompareLocation: brand_location[0] });
    }
    if (
      utils.isEmptyObject(selectedLocation) ||
      (selectedLocation.brand_ids &&
        selectedLocation.brand_ids.includes(selectedLocation.studioId))
    ) {
      this.props.getMetrics({
        business_id: auth.studio_id || business.id,
        selectedDateRange: selectedDateRange,
        selectedUserType: selectedUserType,
        brandlocation: true,
      });
    } else {
      this.props.getMetrics({
        business_id: auth.studio_id || business.id,
        selectedDateRange: selectedDateRange,
        selectedUserType: selectedUserType,
        brandOnly: true,
      });
      this.props.getMetrics({
        business_id: selectedLocation.studioId,
        selectedDateRange: selectedDateRange,
        selectedUserType: selectedUserType,
      });
    }
  };
  onLocationChange = (location) => {
    const { auth, business } = this.props;
    const { selectedDateRange, selectedUserType } = this.state;
    let brand_location = business.locations.filter((location) =>
      location.brand_ids.includes(location.studioId),
    );
    if (brand_location.length > 0) {
      this.setState({ selectedCompareLocation: brand_location[0] });
    }

    if (location.brand_ids && location.brand_ids.includes(location.studioId)) {
      this.props.getMetrics({
        business_id: auth.studio_id || business.id,
        selectedDateRange: selectedDateRange || 'FOUR_WEEKS',
        selectedUserType: selectedUserType || 'ALL',
        brandlocation: true,
      });
    } else {
      this.props.getMetrics({
        business_id: auth.studio_id || business.id,
        selectedDateRange: selectedDateRange || 'FOUR_WEEKS',
        selectedUserType: selectedUserType || 'ALL',
        brandOnly: true,
      });
      this.props.getMetrics({
        business_id: location.studioId,
        selectedDateRange: selectedDateRange || 'FOUR_WEEKS',
        selectedUserType: selectedUserType || 'ALL',
      });
    }
    this.props.setSelectedLocation(location);
  };

  handleStatusChange = (event) => {
    console.log('event selectedDateRange', event);
    this.setState(
      {
        selectedDateRange: event,
        dateRangeDropdownVisibility: !this.state.dateRangeDropdownVisibility,
      },
      () => {
        this.fetchMetricsOnFilterChange();
      },
    );
  };

  handleUserTypeChange = (event) => {
    console.log('event selectedUserType', event);
    this.setState(
      {
        selectedUserType: event,
        userTypeDropdownVisibility: !this.state.userTypeDropdownVisibility,
      },
      () => {
        this.fetchMetricsOnFilterChange();
      },
    );
  };

  setStatusDropdownVisibility() {
    this.setState({
      dateRangeDropdownVisibility: !this.state.dateRangeDropdownVisibility,
    });
  }

  setuserTypeDropdownVisibility() {
    this.setState({
      userTypeDropdownVisibility: !this.state.userTypeDropdownVisibility,
    });
  }

  setDropDownLocation = (location) => {
    this.setState({
      selectedCompareLocation: location,
    });
  };

  render() {
    const {
      dateRangeDropdownVisibility,
      userTypeDropdownVisibility,
      selectedDateRange,
      selectedUserType,
      activeOutcomesTab,
      selectedCompareLocation,
      isChartModalOpen,
    } = this.state;
    const { business, dashboard, auth } = this.props;
    const { booking_software } = auth;
    const { metrics, callCount, outcome_visualization_available } = dashboard;
    const {
      info,
      locations,
      isLocationfetchsuccess,
      selectedLocation,
    } = business;
    const id = selectedLocation.studioId || auth.studio_id;

    return (
      <div className="dashboard-container">
        {dashboard && dashboard.callCount > 0 ? (
          <div className="loading-container">
            <Loading />
          </div>
        ) : (
          <>
            <div className="dashboard-header"></div>
            <div className="dashboard">
              <div className="dashboard__overview">
                <div className="title">
                  <div>
                    <span>Dashboard</span>
                  </div>
                  <div className="actions">
                    {isLocationfetchsuccess && (
                      <div className="drop-down padding-right">
                        <BusinessName
                          info={info}
                          locations={locations}
                          setSelectedLocation={this.onLocationChange}
                          selectedLocation={selectedLocation}
                        />
                      </div>
                    )}
                    <div className="drop-down margin-right">
                      <a
                        href="#"
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();
                          this.setStatusDropdownVisibility(true);
                        }}
                      >
                        <span className="range-display">
                          {rangeType[selectedDateRange]}
                        </span>{' '}
                        <i className="material-icons">arrow_drop_down</i>
                      </a>
                      <StatusSelectDropdown
                        visibility={dateRangeDropdownVisibility}
                        position="tl"
                        onVisibilityChange={(visibility) => {
                          this.setStatusDropdownVisibility(visibility);
                        }}
                        selectedOption={selectedDateRange}
                        className="menu__dropdown"
                        onChange={(event) => {
                          this.handleStatusChange(event);
                        }}
                      />
                    </div>
                    {booking_software !== 'SCIBLER' && (
                      <div className="drop-down">
                        <a
                          href="#"
                          onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            this.setuserTypeDropdownVisibility(true);
                          }}
                        >
                          <span className="range-display">
                            {guestType[selectedUserType]}
                          </span>{' '}
                          <i className="material-icons">arrow_drop_down</i>
                        </a>
                        <UserTypeDropdownVisibility
                          visibility={userTypeDropdownVisibility}
                          position="tl"
                          onVisibilityChange={(visibility) => {
                            this.setuserTypeDropdownVisibility(visibility);
                          }}
                          selectedOption={selectedUserType}
                          className="menu__dropdown"
                          onChange={(event) => {
                            this.handleUserTypeChange(event);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {metrics && metrics.trend && (
                  <div className="bar-table">
                    <StatsContnet
                      result={metrics}
                      business={business}
                      setDropDownLocation={this.setDropDownLocation}
                      selectedLocation={selectedCompareLocation}
                      {...this.props}
                    />
                  </div>
                )}
              </div>
              {metrics && metrics.conversation_outcomes && (
                <div className="dashboard__piechart">
                  <div className="chart-holder">
                    <div className="chart-header">
                      <div className="chart-header_title">
                        OUTCOMES{' '}
                        <div className="braces">
                          ({rangeType[metrics.conversation_outcomes.range_type]}
                          )
                        </div>
                      </div>
                      <div className="d-flex">
                        {outcome_visualization_available && 
                          <div
                            className="download-button"
                            onClick={this.openChartModal}
                          >
                            Journey Insights
                          </div>
                        }
                        <div
                          className="download-button"
                          onClick={this.downloadReport}
                        >
                          <img src={FileDownload} />
                          Download{' '}
                          {
                            rangeType[metrics.conversation_outcomes.range_type]
                          }{' '}
                          report
                        </div>
                      </div>
                    </div>
                    <div className="charts">
                      <Graphs
                        conversation_outcomes={metrics.conversation_outcomes}
                        activeOutcomesTab={activeOutcomesTab}
                        auth={auth}
                      />
                      {/* <LocationData conversation_outcomes={metrics.conversation_outcomes} activeOutcomesTab={activeOutcomesTab}/> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        <Footnote />
        <CsvChartModal
          isOpen={isChartModalOpen}
          onClose={this.closeChartModal}
          selectedDateRange={selectedDateRange}
          selectedUserType={selectedUserType}
        />
      </div>
    );
  }
}

Dashboard.defaultProps = {
  getMetrics: () => {},
};

Dashboard.propTypes = {
  getMetrics: PropTypes.func,
  downloadReport: PropTypes.func,
};
